import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { toggleDialog } from 'actions/view'

const TooltipContent = ({ vr_role, a2p10dlcExists, toggleDialog }) => {
  return vr_role === 'acctowner' ? (
    a2p10dlcExists ? (
      <div>
        Application pending: Your A2P 10DLC compliance form is under review.
        We'll notify you once the process is complete. Thank you for your
        patience.
      </div>
    ) : (
      <div>
        Activate messaging: Please complete your A2P 10DLC compliance
        application to enable text messaging.{' '}
        <span
          style={{
            color: '#d89300',
            textDecoration: 'underline',
            cursor: 'pointer',
          }}
          onClick={() =>
            toggleDialog({
              open: true,
              dialog: 'A2P10DLC',
            })
          }
        >
          Fill out the form.
        </span>
      </div>
    )
  ) : a2p10dlcExists ? (
    <div>
      Message feature pending: The account owner has submitted the A2P 10DLC
      compliance application, and it's currently under review. Please wait for
      further updates.
    </div>
  ) : (
    <div>
      Message feature pending: Please contact your account owner to complete the
      A2P 10DLC compliance process to activate messaging.
    </div>
  )
}

export default connect(
  state => ({
    vr_role: state.auth?.session?.idToken?.payload?.['custom:vr_role'],
    a2p10dlcExists: Object.values(state.data?.a2p10dlc || {})?.length,
  }),
  dispatch => bindActionCreators({ toggleDialog }, dispatch),
)(TooltipContent)
